import { Instagram, ArrowUpRight } from "lucide-react";
import { assets, business } from "../data/site";

/**
 * "Follow us on Instagram" — a curated grid of the restaurant's real
 * photoshoot images styled to look like an Instagram profile feed.
 * Each tile links straight to the Instagram profile so visitors are one
 * click away from following.
 *
 * If a live-updating feed is needed later, swap the `photos` array below
 * for API/widget data — the rest of the component stays the same.
 */
export default function InstagramFeed({ heading = "Follow us on Instagram", subheading }) {
  const photos = [
    assets.gallery[0],
    assets.dishes[0],
    assets.gallery[3],
    assets.dishes[2],
    assets.gallery[6],
    assets.dishes[4],
    assets.gallery[9],
    assets.dishes[6],
  ];

  return (
    <section data-testid="instagram-feed" className="bg-[#0a0a0a] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-16 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10">
          <div>
            <p className="text-[#ffd100] font-semibold uppercase tracking-[0.2em] text-sm mb-2 inline-flex items-center gap-2">
              <Instagram size={16} /> @shaancurryhouseottawa
            </p>
            <h2 className="font-display text-4xl md:text-5xl font-bold text-white tracking-tight">{heading}</h2>
            {subheading && (
              <p className="text-neutral-400 text-lg mt-3 max-w-xl">{subheading}</p>
            )}
          </div>
          <a
            href={business.instagram}
            target="_blank"
            rel="noreferrer"
            data-testid="ig-profile-btn"
            className="inline-flex items-center gap-2 bg-[#ffd100] text-[#0a0a0a] font-bold px-6 py-3 rounded-full hover:bg-[#e5bc00] transition-colors shrink-0"
          >
            <Instagram size={18} /> Follow us
            <ArrowUpRight size={18} />
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {photos.map((src, i) => (
            <a
              key={i}
              href={business.instagram}
              target="_blank"
              rel="noreferrer"
              data-testid={`ig-tile-${i}`}
              className="group relative aspect-square overflow-hidden rounded-xl bg-[#141414]"
              aria-label="Open on Instagram"
            >
              <img
                src={src}
                alt="Shaan Curry House food"
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/50 transition-colors duration-300 grid place-items-center">
                <Instagram
                  size={28}
                  className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300 drop-shadow-lg"
                />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
